<template>
  <div class="page-con">
    <div class="page-con-header clearfix sel-modal-header">
      <Button
          type="primary"
          @click="addShipName"
          v-if="isHavePermission('shipQurty:createShipName')"
      >
        新增船名翻译
      </Button>
      <div style="float:right">
        <vxe-input
            v-model="keyWordEn"
            style="margin-left: 10px"
            type="search"
            placeholder="搜英文名称"
            @search-click="search"
            @keyup.enter.native="search"
        ></vxe-input>
        <vxe-input
            v-model="keyWordCn"
            style="margin-left: 10px"
            type="search"
            placeholder="搜当前中文名称"
            @search-click="search"
            @keyup.enter.native="search"
        ></vxe-input>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          align="center"
          border="none"
          :loading="loading"
          :data="tableData"
      >
        <vxe-table-column field="id" title="序号"></vxe-table-column>
        <vxe-table-column title="操作" v-if="isHavePermission('shipQurty:createShipName')">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" style="margin-left: 10px; color: #666" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo" @click="editShipName(row)">设置</Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="nameEn" title="英文名称"></vxe-table-column>
        <vxe-table-column field="nameCnFirst" title="初始档案中文名称"></vxe-table-column>
        <vxe-table-column field="countDataFirst" title="初始档案出现次数"></vxe-table-column>
        <vxe-table-column field="nameCnCur" title="当前中文名称"></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal
        v-model="modalVisible"
        :title="title"
        width="400"
        height="250"
        position="center"
        resize
        destroy-on-close
    >
      <vxe-form
          ref="xForm"
          title-align="right"
          title-width="80"
          :rules="reRules"
          :data="charData"
          @submit="commit"
      >
        <vxe-form-item title="英文" field="nameEn" span="24">
          <template v-slot="scope">
            <vxe-input
                type="text"
                v-model="charData.nameEn"
                placeholder="请输入英文"
                :disabled="commitType === 'edit'"
                @input="$refs.xForm.updateStatus(scope)"
                @blur="checkName(charData.nameEn)"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="中文" field="nameCnCur" span="24">
          <template v-slot="scope">
            <vxe-input
                type="text"
                v-model="charData.nameCnCur"
                placeholder="请输入中文"
                @input="$refs.xForm.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-form-item>

        <vxe-form-item align="right" span="24" style="margin-top: 10px">
          <vxe-button style="width: 100px; border-radius: 0px" @click="modalVisible = false"
          >取消
          </vxe-button>
          <vxe-button type="submit" status="primary" style="width: 100px; border-radius: 0px"
          >确定
          </vxe-button>
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import {showLoading, hideLoading} from "@/utils/util";

  export default {
    mixins: [getAuthOrization],
    data() {
      return {
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        loading: false,
        keyWordEn: "",
        keyWordCn: "",
        tableData: [],
        modalVisible: false,
        title: "",
        reRules: {
          nameEn: [{required: true, message: "请输入英文名"}],
          nameCnCur: [{required: true, message: "请输入中文名"}],
        },
        charData: {
          nameEn: "",
          nameCnCur: "",
        },
        commitType: "add",
      };
    },
    mounted() {
      this.$bus.$on("船名数据库", () => {
        this.keyWordEn = null;
        this.keyWordCn = null;
        this.getData();
      });
      this.getData();
    },
    methods: {
      async checkName(name) {
        if (this.commitType === "edit") return;
        let params = {
          nameEn: name,
          page: this.page.currentPage,
          rows: this.page.pageSize,
        };
        let res = await $api.shipQurty.get("getShipNameCnList", params);
        if (res.code === 1 && res.data.list && res.data.list.length > 0) {
          this.$Message.error("该英文名称已存在");
        }
      },
      addShipName() {
        this.title = "新增船名翻译";
        this.modalVisible = true;
        this.charData.nameCnCur = null;
        this.charData.nameEn = null;
        this.commitType = "add";
      },
      editShipName(row) {
        this.title = "设置";
        this.modalVisible = true;
        this.charData.nameCnCur = null;
        this.charData.nameEn = row.nameEn;
        this.charData.id = row.id;
        this.commitType = "edit";
      },
      async commit() {
        //POST /manage/seachart/addShipNameCn
        let res;
        if (this.commitType === "add") {
          let params = {
            nameCnCur: this.charData.nameCnCur,
            nameEn: this.charData.nameEn,
          };
          res = await $api.shipQurty.request("addShipNameCn", params);
        } else {
          //POST /manage/seachart/updateShipNameCn
          let params = {
            nameCnCur: this.charData.nameCnCur,
            id: this.charData.id,
          };
          res = await $api.shipQurty.request("updateShipNameCn", params);
        }

        if (res.code === 1) {
          this.modalVisible = false;
          let text = this.commitType === "add" ? "添加成功" : "设置成功";
          this.$Message.success(text);
          this.getData();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      search() {
        this.page.currentPage = 1;
        this.getData();
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.getData();
      },
      async getData() {
        this.loading = true;
        let params = {
          nameEn: this.keyWordEn,
          nameCn: this.keyWordCn,
          page: this.page.currentPage,
          rows: this.page.pageSize,
        };
        let res = await $api.shipQurty.get("getShipNameCnList", params);
        if (res.code === 1) {
          this.page.totalResult = res.data.total;
          this.tableData = res.data.list;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
    },
  };
</script>

<style></style>
